'use client';

import NavFooterLayout from 'src/components/Layouts/NavFooterLayout';
import TradePageGridAndCustomiser from 'src/components/TradePageGrid/TradePageGridAndCustomiser';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { OrderbookSubscriptionProvider } from 'src/providers/orderbook/OrderbookSubscriptionProvider';

export default function Index() {
	const isMobileScreenSize = useIsMobileScreenSize();

	return (
		<OrderbookSubscriptionProvider>
			<NavFooterLayout overflowAuto hideScroll={isMobileScreenSize}>
				<TradePageGridAndCustomiser />
			</NavFooterLayout>
		</OrderbookSubscriptionProvider>
	);
}
